import { render } from "./InvoiceDisplay.vue?vue&type=template&id=1556a558&scoped=true"
import script from "./InvoiceDisplay.vue?vue&type=script&lang=js"
export * from "./InvoiceDisplay.vue?vue&type=script&lang=js"

import "./InvoiceDisplay.vue?vue&type=style&index=0&id=1556a558&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1556a558"]])

export default __exports__